module.exports = __webpack_public_path__ + "img/Stadtwerke-Oelsnitz.e0817c96.jpg";